import type {MutationFunction} from '@apollo/react-common';
import {useMutation} from '@apollo/react-hooks';

import type {
    GetCalendarSync as GetCalendarSyncQuery,
    setGoogleCalendarSyncIsEnabled as SetGoogleCalendarSyncIsEnabledMutation,
    setGoogleCalendarSyncIsEnabledVariables as SetGoogleCalendarSyncIsEnabledMutationVariables,
} from 'nutshell-graphql-types';

import SET_GOOGLE_CALENDAR_SYNC_IS_ENABLED from '../mutations/set-google-calendar-sync-is-enabled.graphql';
import GET_CALENDAR_SYNC_QUERY from '../queries/get-calendar-sync.graphql';

export function useSetGoogleCalendarSyncIsEnabled(): {
    setGoogleCalendarSyncIsEnabled: (isEnabled: boolean) => Promise<any>;
    enableGoogle: MutationFunction<
        SetGoogleCalendarSyncIsEnabledMutation,
        SetGoogleCalendarSyncIsEnabledMutationVariables
    >;
    isLoading: boolean;
} {
    const [setGoogleCalendarSyncIsEnabled, {loading}] = useMutation<
        SetGoogleCalendarSyncIsEnabledMutation,
        SetGoogleCalendarSyncIsEnabledMutationVariables
    >(SET_GOOGLE_CALENDAR_SYNC_IS_ENABLED);

    return {
        setGoogleCalendarSyncIsEnabled: (isEnabled: boolean) => {
            return setGoogleCalendarSyncIsEnabled({
                variables: {isEnabled},
                update: (proxy, mutationResults) => {
                    const cacheResult: GetCalendarSyncQuery | null | undefined = proxy.readQuery({
                        query: GET_CALENDAR_SYNC_QUERY,
                    });

                    if (!cacheResult || !cacheResult.loggedInUser) {
                        return;
                    }

                    const updatedCalendarSync =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.setGoogleCalendarSyncIsEnabled &&
                        mutationResults.data.setGoogleCalendarSyncIsEnabled.calendarSync;

                    if (!updatedCalendarSync) return;

                    proxy.writeQuery({
                        query: GET_CALENDAR_SYNC_QUERY,
                        data: {
                            loggedInUser: {
                                ...cacheResult.loggedInUser,
                                calendarSync: updatedCalendarSync,
                            },
                        },
                    });
                },
            });
        },
        enableGoogle: setGoogleCalendarSyncIsEnabled,
        isLoading: loading,
    };
}
